import { Component } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { environment } from '../environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'DRPI';
  envi = environment.production;

  constructor(public updates: SwUpdate) {
    updates.available.subscribe(event => {
    });
    updates.activated.subscribe(event => {
    });
    updates.available.subscribe(event => {
      updates.activateUpdate().then(() => document.location.reload());
    });

    if (this.updates.isEnabled) {
      // Se dispara cuando hay una nueva versión disponible
      this.updates.available.subscribe(() => {
        this.updates.activateUpdate().then(() => {
          document.location.reload();
        });
      });
    }
  }
}
